import ABI from '../assets/abi/Abi.json'

export const addresses: any = {
    'Cacti': {
        97: { // testnet
            'address': '0x99076bEf28B10De552f68D412a3D6eBdd03eA4a2',
            'abi': ABI
        },
        56: { // mainnet
            'address': '0x9432e72f68614fFdD3BA82616AC59e878284Aac4',
            'abi': ABI
        },
    }
}